export type AuthLink = {
    readonly href: string;
};

type AuthFlowLinks = {
    readonly recoverUsername: AuthLink;
    readonly initiateAccountRecovery: AuthLink;
    readonly initiatePasswordChange: AuthLink;
    readonly self: AuthLink;
    readonly checkUsernamePassword: AuthLink;
};

export type CheckUsernamePasswordRequest = {
    username: string;
    password: string;
    url: string;
};

export type AuthFlowState = {
    readonly id: string;
    readonly status: string;
    readonly _links: AuthFlowLinks;
    readonly resumeUrl?: string;
};

export interface AuthRedirect {
    readonly location: string;
}

export interface AuthRedirectWithStatus extends AuthRedirect {
    readonly status: 'RESUME' | 'MUST_CHANGE_PASSWORD';
}

export type AuthFailureDetail = {
    readonly code: string;
    readonly message: string;
    readonly userMessage: string;
};

export type AuthFailureResponse = {
    readonly message?: {
        readonly userMessage: string;
        readonly details: AuthFailureDetail[];
    };
};

export interface AuthFlowStateLink {
    href: string;
}

export interface AuthFlowStateLinks {
    recoverUsername?: AuthFlowStateLink;
    initiateAccountRecovery?: AuthFlowStateLink;
    initiatePasswordChange?: AuthFlowStateLink;
    self: AuthFlowStateLink;
    checkUsernamePassword?: AuthFlowStateLink;
}

export const blankAuthFlowState: AuthFlowState = {
    id: '',
    status: '',
    _links: {
        recoverUsername: {
            href: '',
        },
        initiateAccountRecovery: {
            href: '',
        },
        initiatePasswordChange: {
            href: '',
        },
        self: {
            href: '',
        },
        checkUsernamePassword: {
            href: '',
        },
    },
};

export const USERNAME_PASSWORD_REQUIRED_STATUS = 'USERNAME_PASSWORD_REQUIRED';
export const NEW_PASSWORD_REQUIRED_STATUS = 'NEW_PASSWORD_REQUIRED';
export const RESOURCE_NOT_FOUND_STATUS = 'RESOURCE_NOT_FOUND';
